export function getPlatformEnterLoginCodeFromHash(hash: string): string | null {
  if (!hash.startsWith('#')) return null
  const params = new URLSearchParams(hash.replace(/^#/, ''))
  const loginCode = params.get('login_code')?.trim()
  return loginCode || null
}

function getErrorField(error: any, field: string): string {
  const value =
    error?.response?.data?.error?.[field] ||
    error?.data?.error?.[field] ||
    error?.error?.[field] ||
    error?.[field]
  return typeof value === 'string' ? value.trim() : ''
}

function getPlatformEnterFailureReason(error: unknown): string {
  const key = getErrorField(error, 'key') || getErrorField(error, 'code')
  const message = getErrorField(error, 'message') || (error instanceof Error ? error.message : '')
  const parts = [key, message].filter(Boolean)
  if (parts.length > 0) return parts.join(': ')
  if (typeof error === 'string' && error.trim()) return error.trim()
  return 'unknown error'
}

export function getPlatformEnterFailureMessage(error: unknown): string {
  const reason = getPlatformEnterFailureReason(error)
  return `Arcubase 自动登录失败：${reason}。请从 BotWorks 重新打开应用；如果仍然失败，请联系系统管理员检查 Arcubase 身份绑定和应用访问权限。`
}

export function shouldRenderPlatformEnterRouter(input: {
  appReady: boolean
  platformEnterError: string
}): boolean {
  return input.appReady && !input.platformEnterError
}
